import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  withArrow?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  withArrow = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-sm uppercase tracking-[0.2em] font-medium transition-all duration-300 ease-out border focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-luxury-gold disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-luxury-gold border-luxury-gold text-luxury-black hover:bg-white hover:border-white hover:text-luxury-black',
    secondary: 'bg-transparent border-white text-white hover:bg-white hover:text-luxury-black',
    outline: 'bg-transparent border-luxury-gold text-luxury-gold hover:bg-luxury-gold hover:text-luxury-black'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${widthClass} ${className}`;
  const content = <>
      {children}
      {withArrow && <ArrowRight className="ml-2 h-4 w-4" data-id="element-183" />}
    </>;
  if (href) {
    return <a href={href} className={combinedClassName} {...props as any} data-id="element-184">
        {content}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-185">
      {content}
    </button>;
}